import { application } from "./application";

import { Alert, Modal } from "tailwindcss-stimulus-components";
application.register("alert", Alert);
application.register("modal", Modal);

import RailsNestedForm from "@stimulus-components/rails-nested-form";
application.register("nested-form", RailsNestedForm);

import CategoriesController from "./categories_controller";
application.register("categories", CategoriesController);

import CartImportController from "./cart_import_controller";
application.register("cart-import", CartImportController);

import CategorySelectController from "./category_select_controller";
application.register("category-select", CategorySelectController);

import CustomerSelectController from "./customer_select_controller";
application.register("customer-select", CustomerSelectController);

import FlowbiteModalController from "./flowbite_modal_controller";
application.register("flowbite-modal", FlowbiteModalController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import LoadingController from "./loading_controller";
application.register("loading", LoadingController);

import MaskController from "./mask_controller";
application.register("mask", MaskController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import ProductSelectController from "./product_select_controller";
application.register("product-select", ProductSelectController);

import OrderProductController from "./order_product_controller";
application.register("order-product", OrderProductController);

import OrderTotalController from "./order_total_controller";
application.register("order-total", OrderTotalController);

import PurchaseIntentionFormController from "./purchase_intention_form_controller";
application.register(
  "purchase-intention-form",
  PurchaseIntentionFormController,
);

import SlimSelectController from "./slim_select_controller";
application.register("slim-select", SlimSelectController);

import SupplierSelectController from "./supplier_select_controller";
application.register("supplier-select", SupplierSelectController);

import UserController from "./user_controller";
application.register("user", UserController);
